// extracted by mini-css-extract-plugin
module.exports = {"four-story-slider-wrapper":"_4-story-slider-m__four-story-slider-wrapper__34BVs"};